// import '../../client/vendor/oo_engine.min'
import { getDataAttr } from 'lib/server_params'

export function launchOpinionLabSurvey(country, locale) {
  const w = window,
    o = w.OOo
  const langCode = locale.toLowerCase()

  const pgrp = w.fpti ? w.fpti.pgrp : ''
  const page = w.fpti ? w.fpti.page : ''
  const logId = getDataAttr('logid')

  const customVariables = {
    countryCode: country,
    languageCode: langCode,
    ppgrp: pgrp,
    ppage: page,
    log: logId,
  }

  /* Feedback object configuration */
  o.oo_survey = new o.Ocode({
    referrerRewrite: `${
      location.protocol
    }//surveys.paypal.com/${country}/${locale}/${pgrp}/${page}.page`,
    legacyVariables: customVariables,
  })

  /* Display comment card */
  o.oo_survey.show(w.event, 'exit')
}
